export default {
  companyProfileMetadata: {
    editCompanyTitle: 'Редактировать профиль',
    changeCompanyAboutTitle: 'Редактировать описание компании',
    aboutCompany: 'Расскажите о компании',
    companyDashboardTitle: 'Настройки профиля сотрудника',
    companyDashboardDescription: 'Вы можете изменить видимость блоков на странице персонала.',
    companyDashboardCaption: 'Выбраны блоки',
    noBlocksSelected: 'Не выбрано ни одного блока',
    changeDashboardTitle: 'Настроить видимость блоков',
    deleteManagerTitle: 'Убрать сотрудника из списка менеджеров?',
    deleteManagerButton: 'Да, убрать',
    managersNotSpecified: 'Менеджеры не назначены',
    addManagers: 'Добавить менеджеров',
    changeManager: 'Редактировать менеджера',
    selectModules: 'Выберите модули',
    removeFromOrganizersTitle: 'Убрать сотрудника из списка организаторов?',
    removeFromOrganizersButton: 'Да, убрать',
    organizersNotSpecified: 'Организаторы не назначены',
    deletePortfolioTitle: 'Удалить портфолио?',
    changeServicesTitle: 'Редактировать услуги',
    nameServices: 'Введите название услуги',
    // messages
    successMessages: {
      editCompany: 'Описание компании успешно изменено',
      saveSettings: 'Настройки успешно сохранены',
      deleteManager: 'Сотрудник больше не является менеджером',
      editManagers: 'Список менеджеров успешно изменён',
      removeFromOrganizers: 'Сотрудник больше не является организатором',
      editOrganizers: 'Список организаторов успешно изменён',
      deletePortfolio: 'Портфолио успешно удалено',
      changeServices: 'Услуги успешно изменены',
    },
    errorMessages: {
      editCompany: 'Не удалось изменить описание компании',
      saveSettings: 'Не удалось сохранить настройки',
      deleteManager: 'Не удалось удалить сотрудника из списка менеджеров',
      editManagers: 'Не удалось изменить список менеджеров',
      removeFromOrganizers: 'Не удалось убрать сотрудника из списка организаторов',
      editOrganizers: 'Не удалось изменить список организаторов',
      deletePortfolio: 'Не удалось удалить портфолио',
      changeServices: 'Не удалось изменить услуги',
    },
    //
  },
};
